module.exports = __webpack_public_path__ + "img/8.e2da0389.jpg";